import { Button as KButton } from '@kobalte/core/button'
import type { ComponentProps, JSX } from 'solid-js'
import { Show, splitProps } from 'solid-js'
import { Loader2 } from 'lucide-solid'

type Variant = 'solid' | 'primary' | 'ghost' | 'outline' | 'danger'
type Size = 'sm' | 'md' | 'lg'

export const Button = (
  props: ComponentProps<typeof KButton> & {
    variant?: Variant
    size?: Size
    loading?: boolean
  },
): JSX.Element => {
  const [local, rest] = splitProps(props, ['variant', 'size', 'loading', 'disabled', 'class', 'children'])
  return (
    <KButton
      data-variant={local.variant === 'primary' ? 'solid' : (local.variant ?? 'solid')}
      data-size={local.size ?? 'md'}
      disabled={local.disabled || local.loading}
      class={
        'inline-flex items-center justify-center gap-2 font-medium rounded-md ' +
        'transition-all duration-fast ease-out ' +
        'focus-visible:shadow-ring outline-none ' +
        'disabled:opacity-50 disabled:pointer-events-none ' +
        'active:scale-[0.97] ' +
        // size
        'data-[size=sm]:h-8 data-[size=sm]:px-3 data-[size=sm]:text-sm ' +
        'data-[size=md]:h-10 data-[size=md]:px-4 data-[size=md]:text-base ' +
        'data-[size=lg]:h-12 data-[size=lg]:px-6 data-[size=lg]:text-lg ' +
        // variant
        'data-[variant=solid]:bg-accent data-[variant=solid]:text-white data-[variant=solid]:hover:bg-accent-strong ' +
        'data-[variant=ghost]:bg-transparent data-[variant=ghost]:text-fg data-[variant=ghost]:hover:bg-surface-alt ' +
        'data-[variant=outline]:bg-surface data-[variant=outline]:text-fg data-[variant=outline]:border data-[variant=outline]:border-border data-[variant=outline]:hover:border-border-strong ' +
        'data-[variant=danger]:bg-danger data-[variant=danger]:text-white data-[variant=danger]:hover:opacity-90 ' +
        (local.class ?? '')
      }
      {...rest}
    >
      <Show when={local.loading}>
        <Loader2 size={16} class="animate-spin" aria-label="loading" />
      </Show>
      {local.children}
    </KButton>
  )
}
